import React from 'react';
import { ArrowDown, ArrowUp, Loader2, Percent, PieChart as PieChartIcon } from 'lucide-react';
import { formatPercentage } from './utils';
import { MetricPercentDisplayProps } from './types';


const MetricPercentDisplay: React.FC<MetricPercentDisplayProps> = ({
  percentage,
  percentChange,
  title = 'Metric Distribution',
  className = '',
  isLoading = false,
  emptyStateMessage = 'No data available to display',
}) => {

  if (isLoading) {
    return (
      <div className={`bg-white rounded-lg shadow-md p-6 ${className}`}>
        <div
          className="flex flex-col items-center justify-center"
        >
          <Loader2 className="w-8 h-8 animate-spin text-blue-600 mb-4" />
          <h3 className="text-lg font-medium text-gray-900 mb-2">
            Loading Chart Data
          </h3>
          <p className="text-sm text-gray-600 text-center">
            Processing percentage data...
          </p>
        </div>
      </div>
    );
  }

  if (!percentage) {
    return (
      <div className={`bg-white rounded-lg shadow-md p-6 ${className}`}>
        <div
          className="flex flex-col items-center justify-center"
        >
          <PieChartIcon className="w-12 h-12 text-gray-400 mb-4" />
          <h3 className="text-lg font-medium text-gray-900 mb-2">
            No Data Available
          </h3>
          <p className="text-sm text-gray-600 text-center">
            {emptyStateMessage}
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className={`bg-white rounded-lg shadow-md overflow-hidden items-center h-full ${className}`}>
      {/* Header */}
      <div className="flex justify-between bg-gray-201">
        <div className="flex items-center justify-between w-full">
          <div className="flex gap-2 p-2 pl-4 items-center font-medium">
            <Percent className="w-4 h-4" />
            {title}
          </div>
        </div>
      </div>
      <div className='py-6'>
        <div className='flex text-3xl font-medium justify-center items-center'>
          {formatPercentage(percentage)}
        </div>
        <div className={`flex text-sm font-medium justify-center items-center ${percentChange > 0 ? 'text-green-600' : 'text-red-600'}`}>
          { percentChange > 0 && (
            <div>
              <ArrowUp className="w-3 h-3 text-green-600 mr-1" />
            </div>
          ) }
          { percentChange < 0 && (
            <div>
              <ArrowDown className="w-3 h-3 text-red-600 mr-1" />
            </div>
          ) }
          {formatPercentage(percentChange)}
        </div>

      </div>


    </div>
  );
};

export default MetricPercentDisplay;
